<template>
  <div>
    <BaseTitle :title="isEditable ? $t('content.template_generate_edit') : $t('content.template_generate_view')" />
    <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
    <template v-if="dataExport">
      <div class="d-flex justify-end mb-5" v-if="showExportButton">
        <v-btn color="primary" @click="getExport" :loading="loadingExport" class="btn-primary-custom mb-md-0 mr-md-2">
          {{ $t('content.print') }}
        </v-btn>
      </div>

      <v-card class="pa-8 d-flex justify-space-between">
        <v-row>
          <v-col md="6">
            <span> {{ $t('table.school_name') }} : </span>
            <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.schoolName }}</strong>
          </v-col>
          <v-col md="6" class="d-flex justify-end">
            <span>
              NIS :
            </span>
            <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.studentIdentityNumber }}</strong>
          </v-col>
          <v-col md="6">
            <span> {{ $t('form.address') }} : </span>
            <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.address }}</strong>
          </v-col>
          <v-col md="6" class="d-flex justify-end">
            <span> {{ $t('menu.class') }} : </span>
            <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.classroomName }}</strong>
          </v-col>
          <v-col md="6">
            <span> {{ $t('content.student_name') }} : </span>
            <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.studentName }}</strong>
          </v-col>
          <v-col md="6" class="d-flex justify-end">
            <span> {{ $t('form.schoolyear') }} : </span>
            <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.schoolYear }}</strong>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-5 pa-8">
        <table class="table" cellpadding="0" cellspacing="0" width="100%">
          <thead class="center header-table">
            <tr>
              <th rowspan="2" class="header-table-text first">No</th>
              <th rowspan="2" width="20%" class="header-table-text">{{ $t('menu.course') }}</th>
              <th colspan="4" class="header-table-text last-top" style="height : 75px">
                {{ $t('content.knowladge') }} <v-divider class="mt-2 mb-2" style="border-color: #ffffff" />
              </th>
            </tr>
            <tr>
              <th class="header-table-text">{{ $t('content.minimum_criteria') }}</th>
              <th class="header-table-text">{{ $t('content.value') }}</th>
              <th class="header-table-text">{{ $t('content.predicate') }}</th>
              <th width="35%" class="header-table-text last-bottom">{{ $t('form.desc') }}</th>
            </tr>
          </thead>
          <tbody v-for="(parentData, indexParent) in dataExport.eraporGroups" :key="indexParent">
            <tr class="header-group pa-16">
              <td class="header-group-text" colspan="6">
                <strong class="ml-8">{{ parentData.name }}</strong>
              </td>
            </tr>
            <tr v-for="(childData, indexChild) in parentData.courses" :key="indexChild">
              <td style="text-align: center;">{{ indexChild + 1 }}</td>
              <td style="text-align: center;">{{ childData.courseName }}</td>
              <td style="text-align: center;">{{ childData.minimumCriteria }}</td>
              <td style="text-align: center;">
                <form-group
                  v-if="isEditable"
                  name="Value"
                  :validator="$v.dataExport.eraporGroups.$each[indexParent].courses.$each[indexChild].value"
                  :messages="{
                    between: 'Value should between 0 to 100'
                  }"
                >
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      class="mt-4 mb-1 value-input"
                      v-model.number="childData.value"
                      v-bind="attrs"
                      @input="$v.dataExport.eraporGroups.$each[indexParent].courses.$each[indexChild].value.$touch()"
                    />
                  </template>
                </form-group>
                <span v-else>
                  {{ childData.value }}
                </span>
              </td>
              <td style="text-align: center;">{{ childData.predicate }}</td>
              <td style="text-align: center;">
                <article class="container " v-html="childData.description" />
              </td>
            </tr>
          </tbody>
        </table>

        <v-divider class="mt-4 mb-4" />

        <div class="d-flex justify-space-between align-end flex-wrap">
          <div class="mb-2">
            <v-btn v-if="isEditable" small color="primary" @click="updatePredicate(dataExport)">
              Update Predicate
            </v-btn>
          </div>

          <div class="d-flex align-end flex-column mr-6">
            <div class="d-flex align-start flex-column">
              <form-group :name="$t('form.date')" :validator="$v.form.eraporDate">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    class="mt-4 mb-1"
                    :disabled="!isEditable"
                    v-model="form.eraporDate"
                    v-bind="attrs"
                    hint="Contoh: Bandung, 06 July 2021"
                    :label="isEditable ? $t('form.date') : ''"
                  />
                </template>
              </form-group>

              <span class="mb-16"> {{ $t('roles.teacher') }}, </span>

              <span v-if="dataExport.teacherName"> {{ dataExport.teacherName }}, </span>

              <span> NIP : {{ dataExport.teacherIdentityNumber }} </span>
            </div>
          </div>
        </div>
      </v-card>
      <v-card class="mt-5 pa-8 ">
        <!-- Archivement -->
        <template v-if="dataExport.achievement">
          <div class="kotak pa-5 d-flex d-inline">
            <strong class="ml-2 mt-1" style="color: #6d6d6d;"> C. {{ $t('content.achievement') }}</strong>
            <v-btn v-if="isEditable" color="primary" class="ml-6" @click="addAchievements" icon><v-icon> mdi-plus </v-icon> </v-btn>
          </div>

          <div class="pa-5 mb-6">
            <v-row v-for="(achievements, index) in form.achievements" :key="index">
              <v-col md="3">
                <!-- <form-group :name="$t('content.type_activity')">
                  <template slot-scope="{ attrs }">
                    <v-text-field :disabled="!isEditable" v-model="achievements.activity" v-bind="attrs" :label="$t('content.type_activity')" />
                  </template>
                </form-group> -->
                <v-select :items="predicate" :label="$t('content.type_activity')" v-model="achievements.activity" :disabled="!isEditable" clearable>
                  <template v-slot:item="{ item }">{{ $t(item.text) }}</template>
                  <template v-slot:selection="{ item }">{{ $t(item.text) }}</template>
                </v-select>
              </v-col>
              <v-col md="7">
                <form-group :name="$t('form.desc')">
                  <template slot-scope="{ attrs }">
                    <v-text-field :disabled="!isEditable" v-model="achievements.description" v-bind="attrs" :label="$t('form.desc')" />
                  </template>
                </form-group>
              </v-col>
              <v-col md="2" v-if="isEditable">
                <v-btn color="red" outlined :disabled="!isEditable" @click="deleteAchievements(index)" class="btn-primary-custom mt-2">
                  {{ $t('table.delete') }}
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="!form.achievements.length">
              <div class="app-section-title d-flex justify-center ">
                {{ $t('content.no_data_archiv_title') }}
              </div>
              <div class="d-flex justify-center ">
                <span class="ml-2 mt-1" style="color: #6d6d6d;"> {{ $t('content.no_data_archiv_body') }}</span>
              </div>
            </div>
          </div>
        </template>

        <!-- Extracurricular -->
        <!-- <template v-if="dataExport.extracurricular">
          <div class="kotak pa-5 d-flex d-inline">
            <strong class="ml-2 mt-1" style="color: #6d6d6d;"> C. {{ $t('content.extracurricular') }}</strong>
            <v-btn v-if="isEditable" color="primary" class="ml-6" :disabled="!isEditable" @click="addExtract" icon
              ><v-icon> mdi-plus </v-icon>
            </v-btn>
          </div>

          <div class="pa-5 mb-6">
            <v-row v-for="(extract, index) in form.extracurriculars" :key="index">
              <v-col md="3">
                <form-group :name="$t('content.extract_activities')" :validator="$v.form.name">
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      :disabled="!isEditable"
                      v-model="extract.extracurricularActivity"
                      v-bind="attrs"
                      :label="$t('content.extract_activities')"
                    />
                  </template>
                </form-group>
              </v-col>
              <v-col md="3">
                <form-group :name="$t('content.predicate')">
                  <template slot-scope="{ attrs }">
                    <v-text-field :disabled="!isEditable" v-model="extract.predicate" v-bind="attrs" :label="$t('content.predicate')" />
                  </template>
                </form-group>
              </v-col>
              <v-col md="4">
                <form-group :name="$t('form.desc')">
                  <template slot-scope="{ attrs }">
                    <v-text-field :disabled="!isEditable" v-model="extract.description" v-bind="attrs" :label="$t('form.desc')" />
                  </template>
                </form-group>
              </v-col>
              <v-col md="2">
                <v-btn color="red" outlined :disabled="!isEditable" @click="deleteExtract(index)" class="btn-primary-custom mt-2">
                  {{ $t('table.delete') }}
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="!form.extracurriculars.length">
              <div class="app-section-title d-flex justify-center ">
                {{ $t('content.no_data_extract_title') }}
              </div>
              <div v-if="isEditable" class="d-flex justify-center ">
                <span class="ml-2 mt-1" style="color: #6d6d6d;"> {{ $t('content.no_data_extract_body') }}</span>
              </div>
            </div>
          </div>
        </template> -->

        <!-- Attendance -->
        <div class="kotak pa-5">
          <strong class="ml-2" style="color: #6d6d6d;"> D. {{ $t('menu.attendance') }}</strong>
        </div>
        <div class="pa-5  mb-6">
          <v-row>
            <v-col md="4">
              <span> {{ $t('content.attendance_item.sick') }} : </span>
              <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.attendance?.sick }} {{ $t('content.day') }}</strong>
            </v-col>
            <v-col md="4">
              <span> {{ $t('content.attendance_item.excuse_leave') }} : </span>
              <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.attendance?.permission }} {{ $t('content.day') }}</strong>
            </v-col>
            <v-col md="4">
              <span> {{ $t('content.attendance_item.unexcuse_leave') }} : </span>
              <strong class="ml-2" style="color: #6d6d6d;"> {{ dataExport.attendance?.withoutExplanation }} {{ $t('content.day') }}</strong>
            </v-col>
          </v-row>
        </div>

        <v-divider class="mt-4" />
        <div class="d-flex align-end flex-column mr-6">
          <div class="d-flex align-start flex-column">
            <form-group :name="$t('form.date')" :validator="$v.form.eraporDate">
              <template slot-scope="{ attrs }">
                <v-text-field
                  class="mt-4 mb-1"
                  :disabled="!isEditable"
                  v-model="form.eraporDate"
                  v-bind="attrs"
                  hint="Contoh: Bandung, 06 July 2021"
                  :label="isEditable ? $t('form.date') : ''"
                />
              </template>
            </form-group>
            <span class="mb-16">{{ $t('roles.teacher') }},</span>
            <span v-if="dataExport.teacherName">{{ dataExport.teacherName }},</span>
            <span>NIP : {{ dataExport.teacherIdentityNumber }}</span>
          </div>
        </div>
      </v-card>
      <v-card class="mt-5 pa-8 ">
        <div class="kotak pa-5">
          <strong class="ml-2" style="color: #6d6d6d;"> F. Teacher Notes</strong>
        </div>
        <br />
        <form-group name="Teacher Notes" :validator="$v.form.teacherNotes">
          <template slot-scope="{ attrs }">
            <v-textarea
              v-if="isEditable"
              v-bind="attrs"
              v-model="form.teacherNotes"
              placeholder="Teacher notes..."
              :disabled="!isEditable"
              @input="$v.form.teacherNotes.$touch()"
              @blur="$v.form.teacherNotes.$touch()"
            />
            <p v-else class="pa-5" v-html="form.teacherNotes" />
          </template>
        </form-group>

        <v-divider class="mt-4" />
        <div class="d-flex justify-space-between pa-8">
          <div class="d-flex align-start flex-column" style="margin-top:80px;">
            <span>{{ $t('content.knowing') }}</span>
            <span class="mb-16">{{ $t('content.parent_or_guardian') }}</span>
            <span>-------------------------</span>
          </div>
          <div class="d-flex align-start flex-column ">
            <div class="d-flex align-start flex-column">
              <form-group :name="$t('form.date')" :validator="$v.form.eraporDate">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    class="mt-4 mb-1"
                    :disabled="!isEditable"
                    v-model="form.eraporDate"
                    v-bind="attrs"
                    hint="Contoh: Bandung, 06 July 2021"
                    :label="isEditable ? $t('form.date') : ''"
                  />
                </template>
              </form-group>
              <span class="mb-16">{{ $t('roles.teacher') }},</span>
              <span v-if="dataExport.teacherName">{{ dataExport.teacherName }},</span>
              <span>NIP : {{ dataExport.teacherIdentityNumber }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-center pa-8">
          <div class="d-flex align-start flex-column">
            <span>{{ $t('content.knowing') }}</span>
            <span>{{ $t('content.head_master') }}</span>
            <form-group :name="$t('content.head_master_name')" :validator="$v.form.headMasterName">
              <template slot-scope="{ attrs }">
                <v-text-field
                  class="mt-4 mb-1"
                  v-bind="attrs"
                  :disabled="!isEditable"
                  v-model="form.headMasterName"
                  hint="Contoh: Kenneth Phillips M.pd"
                  :label="isEditable ? $t('content.head_master_name') : ''"
                />
              </template>
            </form-group>
            <form-group :name="`NIP`" :validator="$v.form.headMasterIdentityNumber">
              <template slot-scope="{ attrs }">
                <v-text-field
                  class="mt-4 mb-1"
                  type="number"
                  @paste="onPaste"
                  v-number
                  v-bind="attrs"
                  :disabled="!isEditable"
                  v-model="form.headMasterIdentityNumber"
                  hint="Contoh: NIP. 196810182006041006"
                  :label="isEditable ? 'NIP' : ''"
                />
              </template>
            </form-group>
          </div>
        </div>
      </v-card>

      <div class="d-flex justify-end align-center mt-5">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
        <v-btn color="primary" class="btn-primary-custom" v-if="isEditable" @click="submit" :loading="loading">
          {{ $t('submit') }}
        </v-btn>
      </div>
    </template>
    <NoData v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import { maxLength, required, between, numeric } from 'vuelidate/lib/validators';
import FileViewer from '@/components/FileViewerErapor';
import NoData from '@/components/table/NoData';

export default {
  name: 'EraporView',
  components: {
    BaseTitle,
    FileViewer,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        teacherNotes: { required, maxLength: maxLength(255) },
        eraporDate: { required },
        headMasterIdentityNumber: { required },
        headMasterName: { required }
      },
      dataExport: {
        eraporGroups: {
          $each: {
            courses: {
              $each: {
                value: {
                  numeric,
                  between: between(0, 100)
                }
              }
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    showExportButton() {
      return this.dataExport.published && (this.type === 'parent' || this.type === 'student');
    }
  },
  data: () => ({
    dataClass: '',
    listStudent: [],
    loadingLoad: false,
    loadingExport: false,
    loading: false,
    titleData: '',
    search: '',
    dialogSync: false,
    dataExport: '',
    form: {
      teacherNotes: '',
      eraporDate: '',
      headMasterIdentityNumber: '',
      headMasterName: '',
      achievements: []
    },
    dialogPreview: false,
    preview: {},
    predicate: [
      { value: 'A', text: 'A' },
      { value: 'B', text: 'B' },
      { value: 'C', text: 'C' },
      { value: 'D', text: 'D' },
      { value: 'E', text: 'E' }
    ]
  }),
  methods: {
    onPaste(evt) {
      if (evt) {
        evt.preventDefault();
      }
    },
    getData() {
      let method =
        this.type === 'teacher' || this.type === 'school-advisor' || this.type === 'school-admin' ? 'viewDataClassErapor' : 'fetchListStudent';
      this.loadingLoad = true;
      this.$store
        .dispatch(
          `TemplateErapor/${
            this.type === 'teacher' ||
            this.type === 'school-advisor' ||
            this.type === 'school-admin' ||
            this.type === 'parent' ||
            this.type === 'student'
              ? method
              : 'viewDataTemplate'
          }`,
          {
            eraporIntegrationTemplateId: this.$route.params.id,
            studentId: this.$route.params.studentId,
            classroomId: this.$route.params.classId ? this.$route.params.classId : this.$route.params.id
          }
        )
        .then(res => {
          this.form.extracurriculars = res.extracurriculars;
          this.form.achievements = res.achievements;
          this.form.teacherNotes = res.teacherNotes;
          this.form.eraporDate = res.eraporDate;
          this.form.headMasterIdentityNumber = res.headMasterIdentityNumber;
          this.form.headMasterName = res.headMasterName;

          this.dataExport = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    addExtract() {
      this.form.extracurriculars.push({
        description: '',
        extracurricularActivity: '',
        predicate: ''
      });
    },
    getExport() {
      this.loadingExport = true;
      this.$store
        .dispatch('TemplateErapor/exportDataTemplateStudentParent', { classroomId: this.$route.params.classId })
        .then(res => {
          var blobURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `${this.user.fullName} erapor`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `${this.user.fullName} erapor.pdf`,
            size: '186 KB',
            dataUpload: res.data
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);
        })
        .finally(() => (this.loadingExport = false));
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    deleteExtract(item) {
      this.form.extracurriculars.splice(item, 1);
    },
    addAchievements() {
      this.form.achievements.push({
        activity: '',
        description: ''
      });
    },
    deleteAchievements(item) {
      this.form.achievements.splice(item, 1);
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }
      const input = { ...this.form };
      this.loading = true;
      const payload = { studentId: this.$route.params.studentId, eraporIntegrationTemplateId: this.$route.params.id, input };

      this.$store
        .dispatch(`TemplateErapor/editErapor`, payload)
        .then(() => this.$router.push({ name: 'eRaporGeneratorSuccess' }))
        .finally(() => (this.loading = false));
    },
    back() {
      if (!this.type) {
        this.$router.push({ name: 'eRaporGeneratorView' });
      } else if (this.type === 'parent') {
        this.$router.push({ name: 'ParentCourseIndex' });
      } else if (this.type === 'teacher') {
        this.$router.push({ name: 'EraporTeacherView' });
      } else if (this.type === 'student') {
        this.$router.push({ name: 'StudentCourseIndex' });
      } else if (this.type === 'school-advisor') {
        this.$router.push({ name: 'EraporAdvisorView' });
      } else if (this.type === 'school-admin') {
        this.$router.push({ name: 'EraporSchoolAdminView' });
      }
    },
    updatePredicate(groups) {
      const params = {
        eraporIntegrationTemplateId: this.$route.params.id,
        studentId: this.$route.params.studentId
      };

      const payloadRapor = groups.eraporGroups.map(erapor => ({
        ...erapor,
        courses: erapor.courses.map(course => ({
          value: course.value,
          eraporTemplateCourseId: course.eraporTemplateCourseId
        }))
      }));

      const form = {
        params,
        payloadRapor
      };

      this.loading = true;

      this.$store
        .dispatch('TemplateErapor/checkPredicate', form)
        .then(res => {
          this.dataExport.eraporGroups = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getData();
    // this.getDataDetail();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.kotak {
  background-color: #b2ebd0;
  border-radius: 8px;
  height: 63px;
}
th,
td {
  padding: 10px;
}

.header-table {
  background-color: #00bf63;
  border-radius: 8px;
}

.header-table .first {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.header-table .last-top {
  border-top-right-radius: 10px;
}

.header-table .last-bottom {
  border-bottom-right-radius: 10px;
}

.header-table-text {
  color: #ffffff;
  font-family: Montserrat;
}
.header-group {
  background-color: #b2ebd0;
  border-radius: 8px;
  height: 63px;
}
.header-group-text {
  color: #6d6d6d;
  font-family: Montserrat;
}
.header-group td {
  border-radius: 10px;
}

tbody:before {
  content: '@';
  display: block;
  line-height: 10px;
  text-indent: -99999px;
}

.value-input {
  width: 80px;
  margin: 0 auto;
}
</style>
